export default __webpack_public_path__ + "static/media/drivers2.f0d849e4.svg";